import { useDispatch } from 'react-redux';
import Modal from '../custom/Modal';
import ModalClose from './ModalClose';
import { useAppTranslation } from '../../i18n';
import React from 'react';
import { ModalEnum, uiActions } from '../../app/slices/ui.slice';
import XS2APrivacyModalCustomization from '../customizations/XS2APrivacyModalCustomization';

const XS2APrivacyModal = () => {
	const dispatch = useDispatch();
	const { t } = useAppTranslation();

	const handleOnCloseModal = () => {
		dispatch(uiActions.toggleModal(ModalEnum.XS2APRIVACY_MODAL));
	};
	return (
		<Modal onClose={handleOnCloseModal} ariaLabel={t('footer.privacy')}>
			<ModalClose onClose={handleOnCloseModal} />
			<XS2APrivacyModalCustomization />
		</Modal>
	);
};

export default XS2APrivacyModal;
